// Follows the user's preferred language (utils/appLanguage.ts): Arabic when
// that is the preference, English otherwise. No per-screen toggle.
import { getAppLanguage, pickLanguage, useAppLanguage } from "../appLanguage";

export type GCCV2Language = "en" | "ar";

const SUPPORTED_LANGUAGES: readonly GCCV2Language[] = ["en", "ar"];

const resolve = (appLanguage: string): GCCV2Language =>
  pickLanguage(appLanguage, SUPPORTED_LANGUAGES);

export const getGCCV2Language = (): GCCV2Language => resolve(getAppLanguage());

export function useGCCV2Language(): GCCV2Language {
  return resolve(useAppLanguage());
}

// Appended to every GCC v2 prompt so the model can't leave section headings,
// labels, or any other fragment in the other language — a bare "Respond in
// English"/"الرجاء الرد باللغة العربية" was letting headings slip through
// in the wrong language even when the body matched.
const STRICT_LANGUAGE_INSTRUCTION: Record<GCCV2Language, string> = {
  en: "Respond entirely in English. Every part of your response — headings, labels, and body text alike — must be in English, with no words or phrases in any other language.",
  ar: "الرجاء الرد بالكامل باللغة العربية. يجب أن يكون كل جزء من ردك — العناوين والتسميات والنص الأساسي — باللغة العربية، دون أي كلمات أو عبارات بلغة أخرى.",
};

export const getGCCV2StrictLanguageInstruction = (
  language: GCCV2Language,
): string => STRICT_LANGUAGE_INSTRUCTION[language];
